import { MOBILE } from '../app/theme';

const MESSAGE_MIN_H = 190;
const MESSAGE_MAX_H = 420;
const MESSAGE_TO_ACTION_GAP = 42; // includes the form-card bottom padding

export interface TicketMessageLayout {
  height: number;
  sendY: number;
  bottom: number;
}

/** Size the composer without letting it collide with the bottom-pinned send action. */
export function computeTicketMessageLayout(viewportHeight: number, messageY: number): TicketMessageLayout {
  const sendY = viewportHeight - MOBILE.secondaryH - MOBILE.bottomInset;
  const available = sendY - MESSAGE_TO_ACTION_GAP - messageY;
  const height = Math.max(MESSAGE_MIN_H, Math.min(MESSAGE_MAX_H, available));
  return { height, sendY, bottom: messageY + height };
}
